import useStatsig from "./useStatsig";

/**
 * Locally overridable client flags.
 * 
 * Please follow the pattern of isTestGateEnabled.
 */
export const useClientFlags = () => {

  const { getGate } = useStatsig();

  const isTestGateEnabled = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_STATSIG_test_gate === "true"
    ? () => true
    : () => getGate("test_gate");

  const isTieredMembershipSignupEnabled = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_STATSIG_enable_tiered_membership_signup === "true"
    ? () => true
    : () => getGate("enable_tiered_membership_signup");

  const isTieredMembersEnabled = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_STATSIG_enable_tiered_memberships === "true"
    ? () => true
    : () => getGate("enable_tiered_memberships");

  const isLyricsEditorEnabled = process.env.NODE_ENV === "development" && process.env.NEXT_PUBLIC_STATSIG_enable_lyrics_editor === "true"
    ? () => true
    : () => getGate("enable_lyrics_editor");

  return {
    isTestGateEnabled,
    isTieredMembershipSignupEnabled,
    isTieredMembersEnabled,
    isLyricsEditorEnabled,
  };
};
